import { render } from "./QywxOrderDetail.vue?vue&type=template&id=c2176218&scoped=true"
import script from "./QywxOrderDetail.vue?vue&type=script&lang=js"
export * from "./QywxOrderDetail.vue?vue&type=script&lang=js"

import "./QywxOrderDetail.vue?vue&type=style&index=0&id=c2176218&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2176218"],['__file',"src/views/h5/common/basedata/qywxOrder/QywxOrderDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2176218"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2176218', __exports__)) {
    api.reload('c2176218', __exports__)
  }
  
  module.hot.accept("./QywxOrderDetail.vue?vue&type=template&id=c2176218&scoped=true", () => {
    api.rerender('c2176218', render)
  })

}


export default __exports__